import { useState, useEffect } from 'react'
import { defaultDuration } from '../config/page.config';


export const useDebounce = (value: string, milliSeconds: number = defaultDuration) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, milliSeconds);

        return () => {
            clearTimeout(handler);
        };
    }, [value, milliSeconds]);

    return debouncedValue;
};

export default useDebounce;